"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerHash = void 0;
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
var whatwg_url_1 = require("whatwg-url");
var render_app_1 = __importDefault(require("../../utils/render-app"));
var app_1 = __importDefault(require("./app"));
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    },
});
var getCustomerHash = function () {
    var _a;
    var query = new whatwg_url_1.URLSearchParams(window.location.search);
    var rhash = query.get('rhash');
    return rhash || ((_a = window.customer) === null || _a === void 0 ? void 0 : _a.rechargeHash);
};
exports.getCustomerHash = getCustomerHash;
(0, render_app_1.default)('account-app-v3', function () {
    var _a;
    var query = new whatwg_url_1.URLSearchParams(window.location.search);
    var rhash = query.get('rhash');
    var customerHash = rhash || ((_a = window.customer) === null || _a === void 0 ? void 0 : _a.rechargeHash);
    // if a customer has not purchased anything, don't even load the account app
    if (!customerHash) {
        return (React.createElement("div", { className: 'margin-horizontal-auto padding-horizontal-2 medium-padding-horizontal-6', style: { maxWidth: '1175px' } },
            React.createElement("h2", { className: 'h3 margin-top-4' }, "My account"),
            React.createElement("div", { className: 'margin-bottom-4' },
                "Thanks for creating an account! After you",
                ' ',
                React.createElement("a", { className: 'text-underline', href: '/collections/diaper-bundle' }, "purchase a bundle"),
                ' ',
                "you can manage it from this page."),
            React.createElement("div", { className: 'margin-bottom-4' },
                React.createElement("a", { className: 'text-underline', href: '/account/logout' }, "Logout"))));
    }
    return (React.createElement(react_query_1.QueryClientProvider, { client: queryClient },
        React.createElement(app_1.default, null)));
});
